import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeValidable } from '@ami/react/core';
import { Quote } from '../../quotes/quote';
import { QuoteProductConfiguration } from '../../quotes/quoteProductConfiguration';
import InnerStepHeader from '../InnerStepHeader';
import { ProductConfiguration } from '../../products/productConfiguration';
import { Spinner } from '@ami/react/core';
import { Button } from 'reactstrap';
import ReviewQuoteCouplerDecision from '../../quotes/review/quote-products/ReviewQuoteCouplerDecision';
import { PageLoadingSpinner } from '@ami/react/core';

const ValidableContent = makeValidable(
  ({
    quote,
    quoteProductConfiguration,
    onQuoteUpdated,
    getCouplerStyles,
    setDecisionRef,
    onloadSharedDocuments,
  }) => (
    <div className="row justify-content-center">
      {quote.attachmentPoints.map((quoteAttachmentPoint) => {
        return (
          <ReviewQuoteCouplerDecision
            key={quoteAttachmentPoint.id}
            quote={quote}
            attachmentPoint={quoteProductConfiguration.attachmentPoints.find(
              (x) => x.id === quoteAttachmentPoint.id
            )}
            anyCouplerAffected={false}
            quoteAttachmentPoint={quoteAttachmentPoint}
            onQuoteAttachmentPointUpdated={(updatedQuote) =>
              onQuoteUpdated(updatedQuote)
            }
            couplerStyles={getCouplerStyles(quoteAttachmentPoint.id)}
            multiAttachmentPoints={quote.attachmentPoints.length > 1}
            isFromStep2={true}
            isFromStep3={false}
            ref={setDecisionRef}
            onloadSharedDocuments={onloadSharedDocuments}
            machines={[]}
            quoteProductConfiguration={quoteProductConfiguration}
          />
        );
      })}
    </div>
  )
);

export default class CreateQuoteStep2Component extends React.Component {
  constructor(props) {
    super(props);
    this.validableRef = React.createRef();
    this.decisionRefs = [];
    this.getCouplerStyles = this.getCouplerStyles.bind(this);
    this.state = {
      showValidations: false,
      submitting: false,
    };
  }
  static propTypes = {
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration)
      .isRequired,
    onQuoteUpdated: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote).isRequired,
    onloadSharedDocuments: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (window.inventoryQuoteDataViewModel) {
      this.setState({ showValidations: true }, async () => {
        this.setState({ submitting: true });
        await this.decisionRefs[0].saveInternal(this.props.quote);
        this.setState({ submitting: false });
        this.props.onContinue();
      });
    }
  }

  setDecisionRef = (ref) => {
    this.decisionRefs.push(ref);
  };

  getCouplerStyles = (attachmentPointId) => {
    return this.props.quoteProductConfiguration.couplerStyles.filter(
      (x) => x.attachmentPointId === attachmentPointId
    );
  };

  continue = (e) => {
    if (e) e.preventDefault();
    this.setState({ showValidations: true }, async () => {
      if (this.validableRef.current.isValid()) {
        this.setState({ submitting: true });
        await this.decisionRefs[0].saveInternal(this.props.quote);
        this.setState({ submitting: false });
        this.props.onContinue();
      }
    });
  };

  render() {
    const {
      productConfiguration,
      quoteProductConfiguration,
      onQuoteUpdated,
      onCancel,
      quote,
      onloadSharedDocuments,
    } = this.props;
    const { showValidations, submitting } = this.state;
    return (
      <Fragment>
        {submitting && <PageLoadingSpinner />}

        {!submitting && (
          <Fragment>
            <InnerStepHeader
              step1={quote.step1}
              productConfiguration={productConfiguration}
              showHeaderActions={false}
            />
            <div className="container">
              <div className="row my-4">
                <div className="container">
                  <div className="hr-divider">
                    <h3 className="hr-divider-content hr-divider-heading">
                      Lugging Selection
                    </h3>
                  </div>
                  <div className="row quote-step2-content">
                    <div className="col lugging-selections">
                      <ValidableContent
                        showValidations={showValidations}
                        ref={this.validableRef}
                        quote={quote}
                        quoteProductConfiguration={quoteProductConfiguration}
                        onQuoteUpdated={onQuoteUpdated}
                        getCouplerStyles={this.getCouplerStyles}
                        setDecisionRef={this.setDecisionRef}
                        onloadSharedDocuments={onloadSharedDocuments}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row my-4">
                <div className="col text-center">
                  <Button
                    size="lg"
                    color="secondary"
                    onClick={onCancel}
                    className="m-1"
                  >
                    Cancel
                  </Button>
                  <Button
                    size="lg"
                    color="success"
                    onClick={this.continue}
                    className="m-1"
                    disabled={submitting}
                  >
                    Continue <Spinner show={submitting} />
                  </Button>
                </div>
              </div>
            </div>
          </Fragment>
        )}


      </Fragment>
    );
  }
}
